import PosthogService from '~/services/posthog/PosthogService';

export interface IWorkedWithInviteClickedPayload {
  professionalId: string;
}

/**
 * Fires when the user clicks "Invite" from the Worked With tab
 * Event: dental_portal:worked_with:invite_clicked
 */
export function fireWorkedWithInviteClicked(payload: IWorkedWithInviteClickedPayload): void {
  PosthogService.getInstance().track('dental_portal:worked_with:invite_clicked', {
    pro_category: 'Worked With',
    professional_id: payload.professionalId,
  });
}
